module.exports = __webpack_public_path__ + "static/img/vision-stick-pferd.8f396db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/neuro/vision-stick-pferd.png
// module id = +PLw
// module chunks = 0